import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'

import { envUtils } from '@/utils/envUtils'

export const S3_FRONTEND_ASSETS_BUCKET = `https://frontend-assets.${domainProvider.TARGET_DOMAIN}`

export const S3_LIVE_CONTENTS_BUCKET = `https://freewheelin-contents.${domainProvider.TARGET_DOMAIN}`
export const S3_DEV_CONTENTS_BUCKET = `https://freewheelin-contents-dev.${domainProvider.TARGET_DOMAIN}`
export const S3_CONTENTS_BUCKET = envUtils.isLive ? S3_LIVE_CONTENTS_BUCKET : S3_DEV_CONTENTS_BUCKET

export const S3_LIVE_USER_UPLOADS_BUCKET = `https://mathflat-user-uploads.s3.ap-northeast-2.amazonaws.com`
export const S3_DEV_USER_UPLOADS_BUCKET = `https://mathflat-user-uploads-dev.s3.ap-northeast-2.amazonaws.com`
export const S3_USER_UPLOADS_BUCKET = envUtils.isLive
  ? S3_LIVE_USER_UPLOADS_BUCKET
  : S3_DEV_USER_UPLOADS_BUCKET

const s3URL = {
  mathflatAssetsBucket: {
    student(url: string) {
      return `${S3_FRONTEND_ASSETS_BUCKET}/student/${url}`
    },
    teacher(url: string) {
      return `${S3_FRONTEND_ASSETS_BUCKET}/teacher/${url}`
    },
    common(url: string) {
      return `${S3_FRONTEND_ASSETS_BUCKET}/common/${url}`
    },
    font(url: string) {
      return `${S3_FRONTEND_ASSETS_BUCKET}/font/${url}`
    },
    graphic(url: string) {
      return `${S3_FRONTEND_ASSETS_BUCKET}/graphic/${url}`
    },
  },
  freewheelinContentsBucket(url: string) {
    return `${S3_CONTENTS_BUCKET}/${url}`
  },
  mathflatUserUploadsBucket(url: string) {
    return `${S3_USER_UPLOADS_BUCKET}/${url}`
  },
}

export default s3URL
